import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_SFTP_CREDENTIALS_MUTATION = gql`
  mutation setSftpCredential(
    $data: SftpCredentialCreateInput!
  ) {
    setSftpCredential(data: $data) {
      id
      username
      port
      host
      remotePath
      branchId
      valid
    }
  }
`;

@Injectable({ providedIn: 'root' })
export class SetSftpCredentialMutation extends Mutation<RootMutation> {
  document = SET_SFTP_CREDENTIALS_MUTATION;
}
